import { render, staticRenderFns } from "./JobDetailsTalentFindNew.vue?vue&type=template&id=fde55ec8&scoped=true"
import script from "./JobDetailsTalentFindNew.vue?vue&type=script&lang=js"
export * from "./JobDetailsTalentFindNew.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsTalentFindNew.vue?vue&type=style&index=0&id=fde55ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde55ec8",
  null
  
)

export default component.exports